"use client";
import React from "react";

import { Dictionary } from "./types";

export type DictionaryLabelContextValue = Dictionary | null;

export const DictionaryLabelContext =
  React.createContext<DictionaryLabelContextValue>(null);
